import { createSaga } from './saga-helpers';

import * as Api from '../api/external-accounts-api';

const watchGetExternalAccounts = createSaga({
    type: 'EXTERNAL_ACCOUNTS_FETCH',
    fn: Api.fetchExternalAccounts,
    args: action => [action.payload],
    successPayload: ({ items, hasMore } = {}, action) => ({
        accounts: items,
        hasMore,
        ...action.payload
    }),
    errorPayload: (e, action) => ({
        message: e.message || e,
        ...action.payload
    })
});

const watchCreateExternalAccount = createSaga({
    type: 'EXTERNAL_ACCOUNT_CREATE',
    fn: Api.createExternalAccount,
    args: action => [action.payload.account],
    successPayload: ({ id: accountId }, action) => ({
        accountId,
        fragment: action.payload.account
    }),
    errorPayload: (e, action) => ({
        message: e.message || e,
        fragment: action.payload.account
    })
});

const watchRemoveExternalAccount = createSaga({
    type: 'EXTERNAL_ACCOUNT_REMOVE',
    fn: Api.removeExternalAccount,
    args: action => [action.payload.accountId],
    successPayload: (response, action) => ({
        accountId: action.payload.accountId
    }),
    errorPayload: (e, action) => ({
        message: e.message || e
    })
});

const watchGetExternalAccountsTeam = createSaga({
    type: 'EXTERNAL_ACCOUNTS_TEAM_FETCH',
    fn: Api.fetchExternalAccountsTeam,
    args: action => [action.payload],
    successPayload: ({ items, hasMore } = {}, action) => ({
        accounts: items,
        hasMore,
        ...action.payload
    }),
    errorPayload: (e, action) => ({
        message: e.message || e,
        ...action.payload
    })
});

const watchCreateExternalAccountTeam = createSaga({
    type: 'EXTERNAL_ACCOUNT_TEAM_CREATE',
    fn: Api.createExternalAccountTeam,
    args: action => [action.payload.account],
    successPayload: ({ id: accountId }, action) => ({
        accountId,
        fragment: action.payload.account
    }),
    errorPayload: (e, action) => ({
        message: e.message || e,
        fragment: action.payload.account
    })
});

const watchRemoveExternalAccountTeam = createSaga({
    type: 'EXTERNAL_ACCOUNT_TEAM_REMOVE',
    fn: Api.removeExternalAccountTeam,
    args: action => [action.payload.accountId],
    successPayload: (response, action) => ({
        accountId: action.payload.accountId
    }),
    errorPayload: (e, action) => ({
        message: e.message || e
    })
});

const sagas = [watchGetExternalAccounts, watchCreateExternalAccount, watchRemoveExternalAccount, watchGetExternalAccountsTeam, watchCreateExternalAccountTeam, watchRemoveExternalAccountTeam];

export default sagas;
